import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/order/icon_ongoing.png'


const _withScopeId = n => (_pushScopeId("data-v-11492059"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fee-detail-content"
}
const _hoisted_2 = { class: "fee-detail-title flex-center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "status"
}
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dagou1" }, null, -1))
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 1,
  class: "status ing"
}
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "name" }
const _hoisted_12 = {
  class: "btn-content",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_13 = {
  key: 0,
  class: "fee-detail-table-container"
}
const _hoisted_14 = { class: "fee-detail-table-container-flex" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"105px"} }, null, -1))
const _hoisted_16 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-number-for-tip" }, "2", -1))
const _hoisted_18 = {
  key: 0,
  class: "receivable-tag"
}
const _hoisted_19 = {
  key: 1,
  class: "receivable-tag"
}
const _hoisted_20 = {
  key: 2,
  class: "receivable-tag",
  style: {"background-color":"#1C9976"}
}
const _hoisted_21 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-number-for-tip" }, "2", -1))
const _hoisted_23 = {
  key: 0,
  class: "receivable-tag"
}
const _hoisted_24 = {
  key: 1,
  class: "receivable-tag"
}
const _hoisted_25 = {
  key: 2,
  class: "receivable-tag",
  style: {"background-color":"#1C9976"}
}
const _hoisted_26 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, .45)","font-size":"20px","font-weight":"900"}
}
const _hoisted_27 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900"}
}
const _hoisted_28 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, 1)","font-size":"20px","font-weight":"900"}
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, .45)","font-size":"20px","font-weight":"900"}
}
const _hoisted_31 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900"}
}
const _hoisted_32 = {
  key: 2,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900"}
}
const _hoisted_33 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-number-for-tip" }, "1", -1))
const _hoisted_35 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_39 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "text"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"8px","flex-shrink":"0"} }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_48 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-number-for-tip" }, "3", -1))
const _hoisted_50 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "red-number-for-tip" }, "3", -1))
const _hoisted_52 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, .45)","font-size":"20px","font-weight":"900"}
}
const _hoisted_53 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900"}
}
const _hoisted_54 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, .45)","font-size":"20px","font-weight":"900"}
}
const _hoisted_55 = {
  key: 1,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900"}
}
const _hoisted_56 = { style: {"font-size":"14px","line-height":"22px"} }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 2 }
const _hoisted_60 = { style: {"padding":"8px 0","max-width":"280px"} }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { style: {"font-size":"14px","line-height":"22px","padding":"0 8px"} }
const _hoisted_63 = { class: "total" }
const _hoisted_64 = {
  key: 0,
  class: "text"
}
const _hoisted_65 = {
  key: 0,
  style: {"color":"rgba(0, 0, 0, .88)","font-size":"20px","font-weight":"900","line-height":"28px","margin-bottom":"20px","text-align":"right"}
}
const _hoisted_66 = { style: {"padding":"16px","border":"1px solid #F5F5F5","background-color":"#FAFAFA"} }
const _hoisted_67 = { style: {"margin-bottom":"8px"} }
const _hoisted_68 = { style: {"display":"flex","align-items":"center","height":"22px"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "red-number-for-tip",
  style: {"margin":"0"}
}, "1", -1))
const _hoisted_70 = { style: {"font-size":"14px","color":"rgba(0, 0, 0, .88)"} }
const _hoisted_71 = { style: {"font-size":"12px","color":"rgba(0, 0, 0, .45)","line-height":"20px","padding-left":"16px"} }
const _hoisted_72 = { style: {"margin-bottom":"8px"} }
const _hoisted_73 = { style: {"display":"flex","align-items":"center","height":"22px"} }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "red-number-for-tip",
  style: {"margin":"0"}
}, "2", -1))
const _hoisted_75 = { style: {"font-size":"14px","color":"rgba(0, 0, 0, .88)"} }
const _hoisted_76 = { style: {"font-size":"12px","color":"rgba(0, 0, 0, .45)","line-height":"20px","padding-left":"16px"} }
const _hoisted_77 = { style: {"margin-bottom":"0px"} }
const _hoisted_78 = { style: {"display":"flex","align-items":"center","height":"22px"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "red-number-for-tip",
  style: {"margin":"0"}
}, "3", -1))
const _hoisted_80 = { style: {"font-size":"14px","color":"rgba(0, 0, 0, .88)"} }
const _hoisted_81 = { style: {"font-size":"12px","color":"rgba(0, 0, 0, .45)","line-height":"20px","padding-left":"16px"} }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { t } from '@/plugins/i18n'
import { computed, ref } from 'vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import { skuFundDetailExport } from '@/apis/fund'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix, isD2C, isJA } from '@/store'
import { ElMessage } from 'element-plus'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { responseReceiptData, ASK_ENUM } from '@/views/setup/components/utils'
import ModalFundFlowContent from '@/views/fund/FundList/components/ModalFundFlowContent.vue'
import { COUNTRY } from '@/global'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: ['info', 'loading', 'stageInfos', 'products', 'countryCode', 'currencyCode', 'isChoice', 'isJPWorder'],
  setup(__props) {

const props = __props
const [getSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)
// stageInfos 分期金额

const store = useStore()
const router = useRouter()
const route = useRoute()

// 下载收据
const fundDetailLoading = ref(false)
// 合计费用
const totalCost = computed(() => {
  const amount = [props.info.allGoodsPrice,
  props.info.goodsAdditionPrice,
  props.info.expressAllAmount,
  props.info.purchasingAllFee].reduce((total, cur) => total + cur, 0)
  return amount.toFixed(props.countryCode !== COUNTRY.CN ? 2 : 0)
})
/** 导出sku资金明细 */
const exportSkuFeeDetail = () => {
  skuFundDetailExport({ platformOrderId: route.params.id }).then(res => {
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    // const fileName = props.rowItemDetail.billNo + ' ' + dayjs().format('YYYY-MM-DD')
    const fileName = t('sku费用明细')
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display:none')
    a.setAttribute('href', objectUrl)
    a.setAttribute('download', fileName)
    a.click()
    URL.revokeObjectURL(objectUrl)
    ElMessage.success(t('导出成功'))
  })
}
const exportFundPdf = (documentHeader?: string) => {
  fundDetailLoading.value = true
  // TODO
  axios({
    method: 'POST',
    url: process.env.VUE_APP_URL + '/settlement/wallet/download/FundDetailByPlatformOrderNo',
    responseType: 'blob',
    headers: {
      'X-AuthShopId': store.getters.curShop,
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: {
      ...props.info,
      documentHeader
    }
  }).then(res => {
    console.log('领收书', res)
    exportFileDownload(res, { type: 'application/pdf', name: t('领收书') })
  }).finally(() => {
    fundDetailLoading.value = false
  })
}

const modalFundFlowContentRef = ref<InstanceType<typeof ModalFundFlowContent>>()

const downloadPDF = async () => {
  if (!isJA()) {
    exportFundPdf()
    return
  }
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  if (lastUseData.askEveryTime === ASK_ENUM.NO_ASK) {
    exportFundPdf(lastUseData.content)
    return
  }
  modalFundFlowContentRef.value?.open(lastUseData.content, (value: string) => {
    exportFundPdf(value)
  })
}
const computePrice = (price: number) => {
  return Math.round(price * 100) / 100
}
const currentUnit = computed(() => showCurrentUnit(props.countryCode === COUNTRY.KR))
const currencyCode = computed(() => {
  const obj: any = {
    KR: 'KRW',
    CN: 'CNY',
    JP: 'JPY'
  }
  const type = props.countryCode ?? 'CN'
  return obj[type]
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (__props.info.platformOrderSettleStatus)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('费用明细')), 1),
          (__props.info.platformOrderSettleStatus === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('订单已清算完毕')), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('订单仍在进行中，当前产生的费用并不是最终实际费用')), 1)
                ])
              ])),
          _createElementVNode("div", _hoisted_12, [
            (__props.info.platformOrderSettleStatus === 3 && !__props.isJPWorder)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn-detail btn btn-down",
                  onClick: exportSkuFeeDetail
                }, _toDisplayString(_unref(t)('导出SKU费用明细')), 1))
              : _createCommentVNode("", true),
            (__props.info.platformOrderSettleStatus === 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "btn-down btn",
                  onClick: downloadPDF
                }, _toDisplayString(_unref(t)('下载收据')), 1))
              : _createCommentVNode("", true),
            (!__props.isJPWorder)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "btn-detail btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('StoreFund', { query: { platformOrderNo: __props.info.platformOrderNo, currencyCode: _unref(currencyCode) } }))))
                }, _toDisplayString(_unref(t)('资金明细3')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (!__props.isChoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_15,
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('商品代金')) + "(" + _toDisplayString(_unref(currencyCode)) + ")", 1),
                        _hoisted_17,
                        (![5, 3].includes(__props.info.platformOrderSettleStatus))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(t)('未清算')), 1))
                          : _createCommentVNode("", true),
                        (__props.info.platformOrderSettleStatus === 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(t)('部分清算')), 1))
                          : _createCommentVNode("", true),
                        (__props.info.platformOrderSettleStatus === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(t)('已经清算')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('商品附加项1')) + "(" + _toDisplayString(_unref(currencyCode)) + ")", 1),
                        _hoisted_22,
                        (![5, 3].includes(__props.info.platformOrderSettleStatus))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)('未清算')), 1))
                          : _createCommentVNode("", true),
                        (__props.info.platformOrderSettleStatus === 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(t)('部分清算')), 1))
                          : _createCommentVNode("", true),
                        (__props.info.platformOrderSettleStatus === 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(t)('已经清算')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_unref(t)('清算后扣除')), 1),
                    _createElementVNode("td", null, [
                      (__props.info.allGoodsPrice === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(t)('待生成')), 1))
                        : _createCommentVNode("", true),
                      (__props.info.allGoodsPrice !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(__props.info.allGoodsPrice), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      ([2, 5].includes(__props.info.platformOrderSettleStatus) && __props.products.every((v) => !v.platformOrderItemAdditionDTOList?.map?.(() => 1)?.length))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "0"))
                        : (__props.info.goodsAdditionPrice === null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              (__props.info.platformOrderSettleStatus !== 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(t)('待生成')), 1))
                                : (__props.info.platformOrderSettleStatus === 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " 0 "))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                      (__props.info.goodsAdditionPrice !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(__props.info.goodsAdditionPrice), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('押金1')), 1),
                        _hoisted_34
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      (__props.stageInfos?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stageInfos, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.stageNo
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('第{day}期', { day: item.stageNo })) + "(" + _toDisplayString(item.freezeRate) + ")：" + _toDisplayString(item.freezeAmount) + " " + _toDisplayString(item.purchaseApplyFlag ? '' : `(${_unref(t)('待付款')})`), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('已退押金/押金')) + "=" + _toDisplayString(__props.info.goodsPriceRefundDeposit ?? 0) + " / " + _toDisplayString(__props.stageInfos.reduce((pre, cur) => pre + cur.freezeAmount, 0)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!__props.stageInfos?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(t)('已退押金/押金')) + "=" + _toDisplayString(__props.info.goodsPriceRefundDeposit) + "/" + _toDisplayString(__props.info.goodsPriceDeposit ?? '-'), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('已退押金/押金')) + "=" + _toDisplayString(__props.info.goodsAdditionPriceRefundDeposit ?? 0) + "/" + _toDisplayString(__props.info.goodsAdditionPriceDeposit ?? '-'), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_unref(t)('扣费明细')), 1),
                    _createElementVNode("td", _hoisted_39, [
                      (__props.info.goodsPrice === null && !(_unref(isD2C)() && __props.info.goodsRefundPrice !== null))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "/"))
                        : _createCommentVNode("", true),
                      (__props.info.goodsPrice !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(t)('商品代金')) + ":" + _toDisplayString(__props.info.goodsPrice ?? '-'), 1))
                        : _createCommentVNode("", true),
                      (_unref(isD2C)() && __props.info.goodsRefundPrice !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_unref(t)('返金')) + ":" + _toDisplayString(__props.info.goodsRefundPrice ?? '-'), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_43, [
                      (
                Object.keys(__props.info.additionSettlementGoodsDetailRespDTOSList ?? {}).length === 0 &&
                Object.keys(__props.info.additionSettlementGoodsDetailBadRespDTOSList ?? {}).length === 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, "/"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.info.additionSettlementGoodsDetailRespDTOSList || []), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text",
                          key: index
                        }, _toDisplayString(item.name) + "：" + _toDisplayString(item.list.map((i) => i.costType === 1
                  ? (i.cost > 0 ? `${i.settlePrice}${_unref(currentUnit)}*${Math.round(i.cost *
                    100)}%*${i.num}${_unref(t)('件')}=${i.settleMoney}${_unref(currentUnit)}`
                    : i.settleMoney +
                    _unref(currentUnit)) :
                  `${i.settlePrice}${_unref(currentUnit)}*${i.num}${_unref(t)('件')}=${i.settleMoney}${_unref(currentUnit)}`).join(',')), 1))
                      }), 128)),
                      (__props.info.additionSettlementGoodsDetailBadRespDTOS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(t)('商品附加项(返品不可不良品)')) + ":" + _toDisplayString(__props.info.additionSettlementGoodsDetailBadRespDTOS ?
                    computePrice(__props.info.totalAbnormalAdditionAmount) : '-'), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.info.additionSettlementGoodsDetailBadRespDTOSList || []), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text",
                          key: index
                        }, _toDisplayString(item.name) + "：" + _toDisplayString(item.list.map((i) => i.costType === 1
                  ? (i.cost > 0 ? `${i.settlePrice}${_unref(currentUnit)}*${Math.round(i.cost *
                    100)}%*${i.num}${_unref(t)('件')}=${i.settleMoney}${_unref(currentUnit)}`
                    : i.settleMoney +
                    _unref(currentUnit)) :
                  `${i.settlePrice}${_unref(currentUnit)}*${i.num}${_unref(t)('件')}=${i.settleMoney}${_unref(currentUnit)}`).join(',')), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _hoisted_46,
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_47,
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('国内运费2')) + "(" + _toDisplayString(_unref(currencyCode)) + ")", 1),
                        _hoisted_49
                      ])
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('代购手续费')) + "(" + _toDisplayString(__props.isJPWorder ? "JPY" : _unref(currencyCode)) + ")", 1),
                        _hoisted_51
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_unref(t)('实际扣除')), 1),
                    _createElementVNode("td", null, [
                      (__props.info.expressAllAmount === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_unref(t)('待生成')), 1))
                        : _createCommentVNode("", true),
                      (__props.info.expressAllAmount !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(__props.info.expressAllAmount), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      (__props.info.purchasingAllFee === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_unref(t)('待生成')), 1))
                        : _createCommentVNode("", true),
                      (__props.info.purchasingAllFee !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(__props.info.purchasingAllFee), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_unref(t)('扣费明细')), 1),
                    _createElementVNode("td", _hoisted_56, [
                      (__props.info.expressAmount === null && __props.info.expressRefundAmount === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "/"))
                        : _createCommentVNode("", true),
                      (__props.info.expressAmount !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_unref(t)('国内运费2')) + ": " + _toDisplayString(__props.info.expressAmount ?? '/'), 1))
                        : _createCommentVNode("", true),
                      (__props.info.expressRefundAmount !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_unref(t)('国内运费退款')) + ": " + _toDisplayString(__props.info.expressRefundAmount ?? '/'), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_60, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          (!__props.info.purchasingFeeList || __props.info.purchasingFeeList.every((item) => !item.list?.length))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, "/ "))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList((__props.info.purchasingFeeList || []), (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (!!item.list?.length)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        span: 12,
                                        style: _normalizeStyle({ borderRight: index ? '' : '1px solid #ddd' })
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", _hoisted_63, _toDisplayString(item.name) + "：" + _toDisplayString(!__props.info.purchasingFee ? '-' :
                        computePrice(item.list.reduce((total, i) => total +
                          i.settleMoney, 0))) + " " + _toDisplayString(__props.isJPWorder ? '円' : _unref(currentUnit)), 1),
                                            (item.list.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(item.list.map((i) =>
                          `${i.settlePrice}${__props.isJPWorder ? '円' : _unref(currentUnit)} * ${i.num}${_unref(t)('件')} =
                        ${i.settleMoney}${__props.isJPWorder ? '円' : _unref(currentUnit)}`).join(',')), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["style"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              (__props.info.platformOrderSettleStatus === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_unref(t)('合计费用')) + "：" + _toDisplayString(_unref(totalCost)) + _toDisplayString(__props.isJPWorder ? "円" : _unref(currentUnit)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createElementVNode("div", _hoisted_70, "【" + _toDisplayString(_unref(t)('押金1')) + "】", 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('这是提交订单时重新订购（缺货、出现缺陷时重新购买）的临时付款。 包括产品价格和产品选择成本。')), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('一旦最终费用确定，相关费用将全额退还。')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, "【" + _toDisplayString(_unref(t)('商品代金')) + "・" + _toDisplayString(_unref(t)('商品附加项')) + "】", 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('经检验、退货、换货等后，为最终产品价格及产品选择费用。')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, "【" + _toDisplayString(_unref(t)('国内运费2')) + "・" + _toDisplayString(_unref(t)('代购手续费')) + "】", 1)
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('这将是中国境内的最终运费和购买费用。')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_82,
        _createVNode(ModalFundFlowContent, {
          ref: (_value, _refs) => {
            _refs['modalFundFlowContentRef'] = _value
            modalFundFlowContentRef.value = _value
          }
        }, null, 512)
      ], 512)), [
        [_directive_loading, __props.loading]
      ])
    : _createCommentVNode("", true)
}
}

})